import axios from "axios";
import Api from "../../util/Api";

export default {
    setAppConfig({commit}, redirectUrl) {
        Api.getAppConfig()
            .then(resp => {
                commit('setAppConfig', {appConfigData: resp.data, path: redirectUrl})
            })
            .catch(errMsg => {
                console.error('setAppConfig', errMsg);
            })
    },

    getMyMenus({commit}) {
        axios.get(process.env.VUE_APP_BACKEND_URL + '/get-my-menus')
            .then(resp => {
                removeChildArray(resp.data);
                var tempMenuList = resp.data.map(item => {

                    // ha external, akkor nyíljon külön ablakban
                    if (item.external) {
                        item.attributes = {
                            target: '_blank'
                        }
                    }

                    if (item.child && item.child.length > 0) {
                        item.class = 'parent-item';
                        delete item.href;
                    }

                    return item;
                });

                commit('menu_get_success', tempMenuList);
            })
            .catch(err => {
                console.error(err);
                commit('menu_get_error');
            })
    },
    getMyMenusDisabled({commit}) {
        axios.get(process.env.VUE_APP_BACKEND_URL + '/get-my-menus')
        .then(resp => {
            removeChildArray(resp.data);
            var tempMenuList = resp.data.map(item => {

                // ha external, akkor nyíljon külön ablakban
                if (item.external) {
                    item.attributes = {
                        target: '_blank'
                    }
                }

                if (item.child && item.child.length > 0) {
                    item.class = 'parent-item';
                    delete item.href;
                }

                return item;
            });

            tempMenuList.forEach(item => {
                item.disabled = true
                if(item.child){
                    item.child.forEach(childItem => {
                        childItem.disabled = true;
                    })
                }
            })
            commit('menu_get_success', tempMenuList);
        })
        .catch(err => {
            console.error(err);
            commit('menu_get_error');
        })
    },
    getCompanySites({commit}) {
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_BACKEND_URL + '/getCompanySitesByUser')
                .then(resp => {
                    commit('company_sites_get_success', resp.data);
                    resolve(resp)
                })
                .catch(err => {
                    console.error(err);
                    commit('company_sites_get_error');
                    reject(err)
                })
        })
    },
    getAppointmentStatus({commit}) {
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_BACKEND_URL + '/getAppointmentStatus')
                .then(resp => {
                    const {data} = resp || {};
                    let obj = {};
                    for (let i = 0; i < data.length; i++) {
                        obj['--status-' + data[i].tag] = data[i].color;
                    }
                    commit('appointment_status_get_success', obj);
                    resolve(resp)
                })
                .catch(err => {
                    console.error(err);
                    commit('appointment_status_get_error');
                    reject(err)
                })
        })
    },
    // eslint-disable-next-line
    setCompanySiteSession({commit}, companySiteId) {
        return new Promise((resolve, reject) => {
            axios.post(
                process.env.VUE_APP_BACKEND_URL + '/companySite/session',
                JSON.stringify({
                    companySiteId: companySiteId
                }),
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            ).then((resp) => {
                localStorage.setItem("MEDICI_CMPNY_ST_ID", companySiteId);
                resolve(resp)
            })
                .catch(err => {
                    reject(err)
                })
        })
    },
    setSelectedCompanySite({commit}, companySiteId) {
        commit('addSelectedCompanySite', companySiteId);
    },
    setChatOpen({commit}) {
        commit('openChat');
    },
    setAppointmentsOpen({commit}) {
        commit('openAppointments');
    },
    setCloseBoth({commit}) {
        commit('closeBoth');
    },
    changeDefaultColor({commit}, color) {
        commit('changeDefaultColorState', color);
    },
    setAppointmentsDate({commit}, date) {
        commit('changeAppointmentsDate', date);
    },
    setPatientSelect({commit}, bool) {
        commit('changePatientSelect', bool);
    },

    setUnreadedMessageCount({commit}, number) {
        commit('setUnreadedMessageCount', number);
    },
    setExternalAppointmentCount({commit}, number) {
        commit('setExternalAppointmentCount', number);
    },
    setEnvProfile({commit}, envProfile) {
        commit('setEnvProfile', envProfile)
    }
}

function removeChildArray(items) {
    items.forEach(function (item) {
        if (item.child) {
            removeChildArray(item.child);
        }
        if (item.child.length == 0) {
            delete item.child;
        }
    })
}
